import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { FC, useCallback, useMemo } from 'react';
import { dealBoardConfigState } from '../../../../state/DealboardDataState';
import { dealTypeFilterStateDA } from '../../../../state/DealConversionFilterStateJ';

export const DealTypeFilter: FC = () => {
  const [selectedDealType, setSelectedDealType] = useAtom(dealTypeFilterStateDA);
  const dealTypes = useAtomValue(dealBoardConfigState).dealTypes;

  const dealTypeOptions = useMemo(() => {
    return dealTypes.map((dealType) => ({
      id: dealType.id,
      name: dealType.displayName,
      label: dealType.displayName,
    }));
  }, [dealTypes]);

  const handleDealTypeChange = useCallback(
    (event: SelectChangeEvent) => {
      const newValue = event.target.value;
      if (newValue != null) {
        setSelectedDealType(Promise.resolve(Number(newValue)));
      }
    },
    [setSelectedDealType]
  );

  return (
    <Select
      value={String(selectedDealType)}
      onChange={handleDealTypeChange}
      sx={{ minWidth: '10rem', height: '40px', mt: '4px', fontSize: '14px' }}
      inputProps={{ 'aria-label': 'Without label' }}
    >
      {dealTypeOptions.map((type) => (
        <MenuItem key={type.id} value={type.id} style={{ fontSize: '14px' }}>
          {type.name}
        </MenuItem>
      ))}
    </Select>
  );
};
